import Backbone from 'backbone';

import Config from '../config';

import { requestify } from '../utils/promisify';

export { getLocations, getAssignees, getTaskFilters };

function getAssignees(task, params = {}, offset = 0, limit = 1000000) {
    const extendedParams = { ...params, ...getTaskFilters( task ) };
    return getLocations( extendedParams, offset, limit );
}

function getTaskFilters(task) {
    if (!task)
        return {};

    let params = {};
    if (task.get( 'location' ) ) {
        const { lon, lat } = task.get( 'location' );
        params.lon = lon.toFixed( 5 );
        params.lat = lat.toFixed( 5 );
    }

    if (+task.get( 'assigned_organization_id' ))
        params.organizationId = task.get( 'assigned_organization_id' );

    return params;
}

function getLocations(params = {}, offset = 0, limit = 1000000) {
    const get = url => requestify( Backbone.$.getJSON( Config.url( url ) ) );

    let url = `/users/by-distance?apiVersion=1.3&offset=${offset}&limit=${limit}`;

    Object.keys( params ).forEach( name => 
        url = Config.add( url, name, params[name] ) );
 
    return get( url );
}


// WEBPACK FOOTER //
// ./src/js/ds/task.assignee.locations.js